import { Component, OnInit } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { NzProgressFormatter } from 'ng-zorro-antd/progress';
import { FleetBoardModalComponent } from 'src/app/components/profile/fleet-board-modal/fleet-board-modal.component';
import { FleetNodeModalComponent } from 'src/app/components/profile/fleet-node-modal/fleet-node-modal.component';
import { MidjourneyDialogComponent } from '../../components/midjourney/midjourney-dialog/midjourney-dialog.component';
import { FleetApiService } from 'src/app/services/api/fleet-api.service';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { MessageService } from 'src/app/services/message.service';
import { FileApiService } from 'src/app/services/api/file-api.service';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { HttpClient } from '@angular/common/http';
import { tr } from 'date-fns/locale';
import { set } from 'date-fns';
import { environment } from 'src/environments/environment';
import { NzMessageService } from 'ng-zorro-antd/message';

interface UploadResponse {
  data: {
    fileid: string;
    status: any;
  };
}

@Component({
  selector: 'app-midjourney',
  templateUrl: './midjourney.component.html',
  styleUrls: ['./midjourney.component.scss'],
})
export class MidjourneyComponent implements OnInit {
  items = Array(0).fill(0);
  createList = Array(0).fill(0);
  model = localStorage.getItem('model')
    ? localStorage.getItem('model')
    : 'RELAX';
  activeLink: string = 'home'; // 默认激活的链接
  page = 1;
  pageSize = 10;
  isPopupVisible = false;
  mjInfo = {
    rd: '',
    prompt: '', // 提示词
    iw: 1.5,
  };
  mjloading = false;
  modelList = [];
  modelId = 0;
  setActiveLink(link: string) {
    this.activeLink = link;
  }

  constructor(
    private dialog: MatDialog,
    private api: FleetApiService,
    private message: MessageService,
    private apiUser: UserApiService,
    private fileApi: FileApiService,
    private route: ActivatedRoute,
    private http: HttpClient,
    private antMessage: NzMessageService
  ) {
  }

  ngOnInit(): void {
    this.getSeat();
    this.getMjUsage();
    this.getMjDuringList();
    this.getMjModel();
    // this.checkAnnouncementStatus();
    console.log(environment.imgUrl);
  }
  async getMjModel() {
    try {
      this.loading = true;
      const r = await this.apiUser.queryMjModel();
      this.modelList = r.data;
      r.data.map((item: any) => {
        if (item.model_name == this.model?.toLocaleLowerCase()) {
          this.modelId = item.id;
        }
      });
    } catch (error) {
      this.message.open('网络错误');
    } finally {
      this.loading = false;
    }
  }
  showMessageSuccess(data: any): void {
    this.antMessage.remove();
    this.antMessage.success(data);
  }
  showMessageInfo(data: any): void {
    this.antMessage.remove();
    this.antMessage.info(data);
  }
  showSteps() {
    this.dialog.open(MidjourneyDialogComponent, {
      autoFocus: false,
      panelClass: 'midjourney-dialog',
      width: '900px',
    });
  }
  seat: any;
  modelsOriginally: any;
  async getSeat() {
    try {
      this.loading = true;
      const r = await this.apiUser.getMjCount('Active', '');
      this.seat = r.data;
      this.modelsOriginally = this.seat.models;
    } catch (error) {
      this.message.open('网络错误');
    } finally {
      this.loading = false;
      this.getFleetAuthTokens();
    }
  }

  calculatePercent(remain: any, times: any): number {
    const remainValue = Number(remain);
    const timesValue = Number(times);
    return timesValue ? (remainValue / timesValue) * 100 : 0;
  }

  // 用于处理文件选择时触发上传
  handleFileSelect(event: any): void {
    const files = event.target.files;
    // 使用扩展运算符将 FileList 转换为数组
    const filesArray = [...files];
    //console.log(filesArray);
    this.customUpload(filesArray);
  }
  reload() {
    location.reload();
  }
  async reset() {
    this.items = [];
    this.getSeat();
    this.getMjUsage();
  }
  // 自定义文件上传方法
  async customUpload(files: any[]) {
    console.log(files);
    const formData = new FormData();

    // 将文件添加到 FormData 对象中
    files.forEach((file: any) => {
      formData.append('file', file); // 将文件放在 'file' 参数中
    });

    try {
      this.loading = true;
      const r = await this.fileApi.uploadFile(files[0]);
      const fileid = r.data.fileid;
      this.mjInfo.rd = environment.imgUrl + this.fileApi.fileurl(fileid);
      console.log('文件上传成功', this.mjInfo);
      console.log(environment.imgUrl + this.mjInfo.rd);
      //this.message.open('上传成功');
      this.showMessageSuccess('上传成功');
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
  handleKeyPress() {
    this.submitMj();
  }
  // 提交绘画任务
  async submitMj() {
    if (!this.mjInfo.prompt) {
      this.message.open('请输入内容');
      return;
    }
    try {
      this.mjloading = !this.mjloading;
      // console.log(this.mjInfo)
      this.getMjDrawing();
    } catch (error) {
      this.message.open('网络错误');
    } finally {
    }
  }

  checkNode() {
    //目前只有一个节点先不用
    // this.dialog.open(FleetNodeModalComponent, {
    //   data: this.tokens,
    //   panelClass: 'fleet-node-dialog',
    // });
  }

  visit() {}

  // openBoard() {
  //   this.dialog.open(FleetBoardModalComponent, {});
  // }

  // async checkAnnouncementStatus() {
  //   try {
  //     const r = await this.apiUser.checkAnnouncementStatus();
  //     const status = r.data[0].is_computer;
  //     if (!status) {
  //       this.openBoard();
  //     }
  //   } catch (error) {}
  // }

  // explain() {
  //   this.isPopupVisible = !this.isPopupVisible;
  // }

  cards: any[] = [];
  loading = false;
  findFleetCards = async () => {
    let hasMore = true;
    try {
      const r = await this.api.findFleetCards(
        this.tokens.access,
        this.tokens.current,
        this.tokens.Authorization,
        this.node_id,
        this.page,
        this.pageSize
      );
      const list = r.data.list || [];
      this.cards = this.cards.concat(list);
      if (list.length < this.pageSize) {
        hasMore = false;
      } else {
        this.page++;
      }
    } catch (error) {
      this.message.open('网络错误');
    }
    return hasMore;
  };

  tokens: any;
  async getFleetAuthTokens() {
    try {
      this.loading = true;
      const r = await this.apiUser.getFleetAuthTokens();
      this.tokens = r.data;
    } catch (error) {
      this.message.open('网络错误');
    } finally {
      this.loading = false;
      // this.findNodes();
      // this.loginFleet();
    }
  }

  nodeList: any;
  node_id: any;
  nodesLoaded = false;
  // async findNodes() {
  //   try {
  //     this.loading = true;
  //     const r = await this.api.findNodes(
  //       this.tokens.access,
  //       this.tokens.current,
  //       this.tokens.Authorization
  //     );
  //     this.nodeList = r.data.list;
  //     this.node_id = this.nodeList[0].id;
  //     this.nodesLoaded = true;
  //   } catch (error) {
  //     this.message.open('网络错误');
  //   } finally {
  //     this.loading = false;
  //   }
  // }

  models: any[] = [];

  format = (index: number) => (): string => {
    return `${index}`;
  };

  //先调用登录接口 来校对次数
  async getOfficialUserRemain() {
    try {
      this.loading = true;
      const r = await this.api.getOfficialUserRemain(
        this.tokens.access,
        this.tokens.current,
        this.tokens.Authorization
      );
      this.models = r.data;
    } catch (error) {
      this.message.open('网络错误');
    } finally {
      this.loading = false;
    }
  }

  async loginFleet() {
    try {
      this.loading = true;
      const r = await this.api.loginFleet(
        this.seat.car,
        0,
        this.seat.current,
        this.seat.sign,
        this.seat.models,
        this.tokens.access,
        this.tokens.current,
        this.tokens.Authorization
      );
      if (r.code === 200) {
        this.getOfficialUserRemain();
      } else if (r.code === 10001) {
        this.message.open('没有权限');
      } else {
        this.message.open('未知错误');
      }
    } catch (error) {
      this.message.open('网络错误');
    } finally {
      this.loading = false;
    }
  }
  getMonth() {
    const now = new Date();
    const yearMonth = `${now.getFullYear()}${(now.getMonth() + 1)
      .toString()
      .padStart(2, '0')}`;
    return parseInt(yearMonth);
  }
  statistics: any = {};
  async getMjUsage() {
    try {
      this.loading = true;
      const r = await this.apiUser.getMjUsage([this.getMonth()]);
      this.statistics = r.data[0];
    } catch (error) {
      this.message.open('网络错误');
    } finally {
      this.loading = false;
    }
  }
  // 提交绘画任务
  taskObj: any = {};
  async getMjDrawing() {
    try {
      this.loading = true;
      const r = await this.apiUser.getMjDrawing(
        [this.mjInfo.rd],
        this.mjInfo.prompt,
        '1.5',
        localStorage.getItem('model') ? localStorage.getItem('model') : 'RELAX'
      );
      this.getSeat();
      this.showMessageInfo('提交成功，等待绘制中');
      this.taskObj = r.data;
      this.putMjModel();
      if (this.taskObj) {
        this.mjInfo.rd = '';
        setTimeout(() => {
          this.getMjDrawingDetails();
        }, 60000);
      }
    } catch (error) {
      this.message.open('网络错误');
    } finally {
      this.loading = false;
    }
  }
  currentObj: any = {};
  // 查询绘画详情
  async getMjDrawingDetails() {
    try {
      this.loading = true;
      this.mjloading = true;
      const r = await this.apiUser.getMjDrawingDetails(this.taskObj.task_no);
      if (r.data.status == 'SUCCESS') {
        this.items.unshift(r.data);
        this.mjloading = false;
        this.currentObj = r.data;
      } else if (r.data.status == 'FAILURE') {
        this.message.open('生成失败');
        this.items.unshift(r.data);
        this.mjloading = false;
        this.currentObj = r.data;
      } else if (r.data.status == 'WAIT') {
        this.currentObj = r.data;
      } else {
        setTimeout(() => {
          this.mjloading = false;
          this.getMjDrawingDetails();
        }, 30000);
      }
    } catch (error) {
      this.mjloading = false;
      this.message.open('网络错误');
    } finally {
      this.loading = false;
    }
  }
  // 查询进程中的任务
  async getMjDuringList() {
    try {
      this.loading = true;
      const r = await this.apiUser.getMjDrawingList(
        '',
        1,
        99999,
        null,
        null,
        2
      );
      this.createList = r.data.list;
    } catch (error) {
      this.message.open('网络错误');
    } finally {
      this.loading = false;
    }
  }

  // 查询绘画列表
  async getMjDrawingList() {
    this.getMjDuringList();
    try {
      this.loading = true;
      const r = await this.apiUser.getMjDrawingList(
        '',
        1,
        99999,
        null,
        null,
        null
      );
      this.items = [...this.items, ...r.data.list];
    } catch (error) {
      this.message.open('网络错误');
    } finally {
      this.loading = false;
    }
  }
  visible: boolean = false;

  clickMe(): void {
    this.visible = false;
  }

  change(value: boolean): void {
    console.log(value);
  }
  changeMode(value: any) {
    if (value == 'FAST') {
      this.showMessageSuccess('切换成功，当前为fast模式（快速）');
    } else {
      this.showMessageSuccess('切换成功，当前为relax模式（慢速）');
    }
    this.model = value;
    localStorage.setItem('model', value);
    this.modelList.map((item: any) => {
      if (item.model_name == value.toLocaleLowerCase()) {
        this.modelId = item.id;
        console.log(this.modelId);
      }
    });
  }

  // 提交次数扣除
  async putMjModel() {
    try {
      this.loading = true;
      const r = await this.apiUser.putMjModel(this.modelId);
    } catch (error) {
      this.message.open('网络错误');
    } finally {
      this.loading = false;
    }
  }

  handleBack() {
    history.back();
    // window.location.href = document.referrer;
  }
}
